import React from "react";
import PropTypes from "prop-types";
import { Collapse } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

function CollapsableToolbarAtividade({ children, show, classes, ...props }) {
  return (
    <Collapse in={show} timeout={500} className={classes.collapse} {...props}>
      {children}
    </Collapse>
  );
}

CollapsableToolbarAtividade.propTypes = {
  children: PropTypes.node,
  show: PropTypes.bool,
  classes: PropTypes.object,
};

export default withStyles({
  collapse: {
    position: "absolute",
    backgroundColor: "#457ab7",
    top: 0,
    left: 0,
    paddingLeft: 24,
    paddingRight: 24,
    width: "calc(100% + 36px)",
    color: "white",
    zIndex: 3,
  },
})(CollapsableToolbarAtividade);
